import React from "react";
import PinButton from "components/UI/atoms/PinButton";
import { isTrue } from "helpers/utils/validators";

const PinnedSkillCard = ({ skill, onClick, unpin }) => {
  return (
    <div className="border-b py-2 flex-center justify-between">
      <p className="link text-truncate maxw-80p" onClick={onClick}>
        {skill?.title}
      </p>
      <PinButton isPinned={isTrue(skill.pinned)} onClick={unpin} />
    </div>
  );
};

export default PinnedSkillCard;
